<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <h2 class="text-center p-3">สร้างบันทึกส่งของ</h2>
            <div class="row">
                <div class="col-sm-12">
                    <!-- Customer select -->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">เลขที่ใบแจ้งหนี้</label>
                        <div class="col-sm-5">
                            <template v-if="id">
                                <input type="text" class="form-control" disabled
                                       v-model="form.invoice_number"/>
                            </template>
                            <template v-else>
                                <multiselect
                                        @input="getSpecialCustomer"
                                        v-model="form.invoice"
                                        :options="optionInvoice"
                                        :show-labels="false"
                                        track-by="id"
                                        :customLabel="invoiceLabel"
                                        placeholder="เลือกเลขที่ใบแจ้งหนี้">
                                </multiselect>
                            </template>
                        </div>
                    </div>
                    <div class="form-group row ">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">การชำระเงิน</label>
                        <div class="col-sm-8" id="payment_type">
                            <label class="col-form-label">
                                <input  v-model="form.payment_type_id"
                                        type="checkbox"
                                        @change="clearCheckbox(form.payment_type_id)"
                                        value="1"/>
                                &nbsp;ไม่มีเก็บ
                            </label>
                            <label class="col-form-label" style="margin-left: 15px">
                                <input  v-model="form.payment_type_id"
                                        type="checkbox"
                                        value="2"/>
                                &nbsp;มีเก็บเก่า
                            </label>
                            <label class="col-form-label" style="margin-left: 15px">
                                <input  v-model="form.payment_type_id"
                                        :disabled="payment_type_status == 1"
                                        type="checkbox"
                                        value="3"/>
                                &nbsp;มีเก็บใหม่
                            </label>
                        </div>
                    </div>
                    <div class="form-group row ">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">ช่องทางการชำระเงิน</label>
                        <div class="col-sm-8">
                            <label class="col-form-label">
                                <input  v-model="form.transaction_id"
                                        type="checkbox"
                                        name="transaction_type"
                                        value="3"
                                        :disabled="form.payment_type_id == 1"
                                        required/>
                                &nbsp;เงินสด
                            </label>
                            <label class="col-form-label" style="margin-left: 15px">
                                <input  v-model="form.transaction_id"
                                        type="checkbox"
                                        name="transaction_type"
                                        :disabled="form.payment_type_id == 1"
                                        value="1"/>
                                &nbsp;เช็ค
                            </label>
                        </div>
                    </div>
                    <div class="form-group row" >
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ยอดเงินที่รับ
                        </label>
                        <div class="col-sm-8 form-inline form-group">
                            <input  v-model="form.amount"
                                    :disabled="form.payment_type_id == 1"
                                    class="form-control col-sm-6"
                                    type="number"/>
                            <span class="col-sm-2">&nbsp;บาท</span>
                        </div>
                    </div>
                    <div class="form-group row" >
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            หมายเหตุ
                        </label>
                        <div class="col-sm-8 form-inline form-group">
                            <textarea v-model="form.remark" class="form-control col-sm-6"></textarea>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เลือกรูปภาพการส่งของ
                            <br/>
                            **จำนวน 1 ภาพ
                        </label>
                        <div class="col-sm-5 col-form-label text-capitalize ">
                            <b-form-file
                                    v-model="form.image_file"
                                    ref="image_file"
                                    @change="imageFileUpload"
                                    accept="image/*"
                                    placeholder="Choose a file...">
                            </b-form-file>
                        </div>
                    </div>
                    <div v-if="typeof(form.image_file) != 'object'" class="row">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8" v-if="form.id">
                            <a :href="form.image_file" target="_blank">
                                <icon name="image" style="width: 25px" class="primary"></icon>
                                ดูรูปภาพการส่งของ
                            </a>
                        </div>
                    </div>
                    <br>
                </div>
                <br/>
            </div>
            <b-row>
                <div class="col text-center">
                    <button @click="saveExportation"
                            type="button"
                            class="btn btn-success">
                        <icon name="save" style="width: 25px"></icon> บันทึก</button>
                    &nbsp&nbsp
                    <button type="button"
                            class="btn btn-outline-secondary"
                            @click="goToSaveExportationList">
                        <icon name="times" style="width: 25px"></icon> ยกเลิก
                    </button>
                </div>
            </b-row>
            <br/>
        </div>
        <!--<pre class="alert-danger">{{optionInvoice}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";

    export default {
        components: {
            Multiselect,
        },
        name: "save-exportation-form",
        props: {
            id: { default: null }
        },
        data() {
            return {
                items: [
                    {
                        text: "รายการบันทึกส่งของ",
                        to: {name: "save-exportation"}
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
                payment_type_status : 0,
                optionInvoice : [],
            };
        },
        created() {
            console.log(this.id);
            this.$store.dispatch("SaveExportation/getInvoiceByDriver").then(data=>{
                console.log(data);
                this.optionInvoice = data;
            });
            if(this.id){
                this.$store.dispatch("SaveExportation/showSaveExportation",this.id);
            }
            else{
                this.$store.dispatch("SaveExportation/clearFormData");
            }
        },

        computed: {
            ...mapState({
                form : state=>{
                    return state.SaveExportation.form;
                },
            }),
        },
        methods: {
            invoiceLabel (option) {
                return `${option.invoice_id} - ${option.customer ? option.customer.store_name : ''}`
            },
            imageFileUpload:function () {
                let input = event.target;
                this.form.image_file = input.files[0];
            },
            saveExportation(){
                this.form.payment_type_id.includes("1");
                if(!this.form.invoice_number && !this.form.invoice){
                    alert("กรุณาเลือกเลขที่ใบแจ้งหนี้");
                }
                else if(!(this.form.payment_type_id.length > 0)){
                    alert("กรุณาเลือกการชำระเงิน");
                }
                else if((this.form.payment_type_id.includes("2") || this.form.payment_type_id.includes("3"))
                    && !(this.form.transaction_id.length > 0)){
                        alert("กรุณาเลือกช่องทางการชำระเงิน");
                }
                else if((this.form.payment_type_id.includes("2") || this.form.payment_type_id.includes("3"))
                    && !this.form.amount){
                        alert("กรุณาใส่ยอดเงิน");
                }
                else if((this.form.payment_type_id.includes("2") || this.form.payment_type_id.includes("3"))
                    && this.form.amount < 0){
                    alert("กรุณาใส่ยอดเงินให้ถูกต้อง");
                }
                else{
                    this.form.payment_type_id = this.form.payment_type_id.toString();
                    this.form.transaction_id = this.form.transaction_id.toString();
                    if(!this.form.image_file){
                        this.form.image_file = "";
                    }
                    let data = {
                        invoice_id: "",
                        payment_type_id: this.form.payment_type_id,
                        transaction_id: this.form.transaction_id,
                        amount: this.form.amount,
                        remark : this.form.remark,
                        old_invoice_id : "",
                        image_file : this.form.image_file,
                    };
                    if(this.form.invoice){
                        data.invoice_id = this.form.invoice.id;
                    }
                    if(this.form.payment_type_id.includes("2")){
                        if(this.form.old_invoice){
                            data.old_invoice_id = this.form.old_invoice.id;
                        }
                    }
                    console.log(data);

                    let formData = new FormData();
                    formData.append('invoice_id',data.invoice_id);
                    formData.append('payment_type_id',data.payment_type_id);
                    formData.append('transaction_id',data.transaction_id);
                    formData.append('old_invoice_id',data.old_invoice_id);
                    formData.append('amount',data.amount);
                    formData.append('remark',data.remark);
                    formData.append('image_file',data.image_file);
                    if(this.id){
                        formData.append("_method",'put');
                    }
                    console.log(data);
                    this.$store.dispatch("SaveExportation/saveSaveExportation",{
                        id : this.id,
                        data : formData
                    }).then(()=>{
                        this.$store.dispatch("SaveExportation/setSaveExportation");
                    });
                    this.goToSaveExportationList();
                }
            },
            goToSaveExportationList(){
                this.$router.push({
                    name:"save-exportation"
                });
            },
            clearCheckbox(payment_checkbox){
                this.payment_type_status = 0;
                if(payment_checkbox && payment_checkbox.includes("1")){
                    this.form.payment_type_id = ["1"];
                    this.form.transaction_id = [];
                    this.payment_type_status = 1;
                    this.form.amount = "";
                }
            },

            getSpecialCustomer(){
                if(this.form.invoice && this.form.invoice.customer){
                    if(this.form.invoice.customer.special_customer){
                        this.form.payment_type_id = ["1"];
                    }
                    else{
                        this.form.payment_type_id = [];
                    }
                }
            }

        },
    };
</script>

<style scoped>

</style>
